import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import SettingLayer from "../components/SettingLayer";


const Setting = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Settings" />

        {/* SettingLayer */}
        <SettingLayer />


      </MasterLayout>
    </>
  );
};

export default Setting;
